import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import { ThemeProvider } from './contexts/ThemeContext';
import { ToastProvider } from './contexts/ToastContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { CustomizationProvider } from './contexts/CustomizationContext';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LanguageProvider>
      <ThemeProvider>
        <CustomizationProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </CustomizationProvider>
      </ThemeProvider>
    </LanguageProvider>
  </StrictMode>,
);
